<template>
  <div class="tenant bg-contain common-blue-contain">
    <div class="title breadcrumb-tilte">{{ $t('devicesSettingUp') }} > {{ $t('IH5Setting') }}</div>
    <div class="main-content common-table-cnt" v-if="tenantData.sleepNetworkModel">
      <div class="bind search">
        <div class="phone-bind">
          <div class="label-bind">
            <span>{{ $t('sleepMode') }}</span>
          </div>
          <div class="network">
            <span class="explain"
              >{{ $t('network') }}：{{
                tenantData.sleepNetworkModel.value === '-1'
                  ? $t('closeN')
                  : tenantData.sleepNetworkModel.value === '0'
                  ? $t('continuouslyOpen')
                  : $t('openN')
              }}
            </span>
            <span v-if="tenantData.sleepNetworkModel.value >= 1"
              >【{{ $t('interval') }} {{ tenantData.sleepNetworkModel.value }} {{ $t('seconds') }}】</span
            >
          </div>
          <div class="content-bind">
            <span class="explain"
              >GPS：{{
                tenantData.sleepGpsModel.value === '-1'
                  ? $t('closeN')
                  : tenantData.sleepGpsModel.value === '0'
                  ? $t('continuouslyOpen')
                  : $t('openN')
              }}
            </span>
            <span v-if="tenantData.sleepGpsModel.value >= 1"
              >{{ $t('interval') }} {{ tenantData.sleepGpsModel.value }} {{ $t('seconds') }}】</span
            >
          </div>
          <div class="bind-btn real-mode">
            <div class="btn-tip">
              <el-button size="mini" type="primary" @click="isNormalSet('sleep')">{{ $t('setUp') }}</el-button>
              <p class="typeInfo">
                {{ $t('estimatedEndurance')
                }}{{ tenantData.sleepModelPowerWaste ? tenantData.sleepModelPowerWaste.value : '-' }}{{ $t('hour') }}
              </p>
            </div>
          </div>
        </div>
        <div class="phone-bind">
          <div class="label-bind">
            <span>{{ $t('normalMode') }}</span>
          </div>
          <div class="network">
            <span class="explain"
              >{{ $t('network') }}：{{
                tenantData.normalNetworkModel.value === '-1'
                  ? $t('closeN')
                  : tenantData.normalNetworkModel.value === '0'
                  ? $t('continuouslyOpen')
                  : $t('openN')
              }}
            </span>
            <span v-if="tenantData.normalNetworkModel.value >= 1"
              >【{{ $t('interval') }} {{ tenantData.normalNetworkModel.value }} {{ $t('seconds') }}】</span
            >
          </div>
          <div class="content-bind">
            <span class="explain"
              >GPS：{{
                tenantData.normalGpsModel.value === '-1'
                  ? $t('closeN')
                  : tenantData.normalGpsModel.value === '0'
                  ? $t('continuouslyOpen')
                  : $t('openN')
              }}
            </span>
            <span v-if="tenantData.normalGpsModel.value >= 1"
              >【{{ $t('interval') }} {{ tenantData.normalGpsModel.value }} {{ $t('seconds') }}】</span
            >
          </div>
          <div class="bind-btn real-mode">
            <div class="btn-tip">
              <el-button size="mini" type="primary" @click="isNormalSet('normal')">{{ $t('setUp') }}</el-button>
              <p class="typeInfo">
                {{ $t('estimatedEndurance')
                }}{{ tenantData.normalModelPowerWaste ? tenantData.normalModelPowerWaste.value : '-' }}{{ $t('hour') }}
              </p>
            </div>
          </div>
        </div>
        <div class="phone-bind">
          <div class="label-bind real-mode">
            <div>
              <span>{{ $t('realTimeMode') }}</span>
              <p class="typeInfo">{{ $t('caseOfFalling') }}</p>
            </div>
          </div>
          <div class="network">
            <span class="explain">{{ $t('network') }}：{{ $t('continuouslyOpen') }}</span>
          </div>
          <div class="content-bind">
            <span class="explain">GPS：{{ $t('continuouslyOpen') }} </span>
          </div>
          <div class="bind-btn real-mode">
            <div class="btn-tip">
              <span>——</span>
              <p class="typeInfo">
                {{ $t('estimatedEndurance')
                }}{{ tenantData.actualModelPowerWaste ? tenantData.actualModelPowerWaste.value : '-' }}{{ $t('hour') }}
              </p>
            </div>
          </div>
        </div>
        <div class="phone-bind">
          <div class="label-bind">
            <span>{{ $t('callSettings') }}</span>
          </div>
          <div class="network">
            <span class="explain"
              >{{ $t('lastVoiceCall') }}【{{ tenantData.outActualModel.value }}】{{ $t('afterMinutes') }}
            </span>
          </div>
          <div class="content-bind">
            <span class="explain"
              >{{ $t('broadcastVoicePayback') }}【{{ tenantData.broadcastNumInterval.value }}】{{$t('second')}}{{ $t('setUp') }}</span
            >
          </div>
          <div class="bind-btn">
            <el-button size="mini" type="primary" @click="otherSet('conversat')">{{ $t('setUp') }}</el-button>
          </div>
        </div>
        <div class="phone-bind">
          <div class="label-bind">
            <span>{{ $t('positioningSettings') }}</span>
          </div>
          <div class="network">
            <span class="explain"
              >{{ $t('ntervalBaseStation') }}【{{ tenantData.stationStatusRecordInterval.value }}】{{ $t('seconds') }}
            </span>
          </div>
          <div class="content-bind">
            <span class="explain"
              >{{ $t('recordingInterval') }}【{{ tenantData.locationRecordInterval.value }}】{{ $t('seconds') }}
            </span>
          </div>
          <div class="bind-btn">
            <el-button size="mini" type="primary" @click="otherSet('locat')">{{ $t('setUp') }}</el-button>
          </div>
        </div>
        <div class="other-set">
          <div class="other-bind">
            <span>{{ $t('otherSettings') }}</span>
          </div>
          <div class="other-content">
            <div class="other-item">
              <div class="network">
                <span class="explain"
                  >{{ $t('statusRecordInterval') }}【{{ tenantData.deviceStatusRecordInterval.value }}】{{
                    $t('seconds')
                  }}
                </span>
              </div>
              <div class="content-bind">
                <span class="explain"
                  >{{ $t('signRecordingInterval') }}【{{ tenantData.healthStatusRecordInterval.value }}】{{
                    $t('seconds')
                  }}
                </span>
              </div>
            </div>
            <div class="other-item">
              <div class="network">
                <span class="explain"
                  >{{ $t('timealarmInterval') }}【{{ tenantData.staticAlertRecordInterval.value }}】{{ $t('seconds') }}
                </span>
              </div>
              <div class="content-bind">
                <span class="explain"
                  >{{ $t('raiseTheHat') }}【{{ tenantData.inSleepModel.value }}】{{ $t('sleepModeAfterMinutes') }}</span
                >
              </div>
            </div>
          </div>
          <div class="bind-btn">
            <el-button size="mini" type="primary" @click="otherSet('other')">{{ $t('setUp') }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 设备设置/休眠模式 -->
    <el-dialog
      :title="isNormal ? $t('normalMode') : $t('sleepMode')"
      :visible.sync="normalVisible"
      width="430px"
      :close-on-click-modal="false"
      class="other-set"
      :append-to-body="true"
    >
      <el-form :model="isNormalForm">
        <el-form-item :label="$t('network')" :required="true">
          <el-radio-group v-model="isNormalForm.netRadio" @change="onOff">
            <el-radio :label="0" value="0">{{ $t('closeN') }}</el-radio>
            <el-radio :label="1" value="1">{{ $t('openN') }}</el-radio>
          </el-radio-group>
          <div class="select-time" v-if="turnOn">
            <span class="interval">{{ $t('interval') }}：</span>
            <el-select
              v-model="isNormalForm.netValue"
              filterable
              :placeholder="$t('enterTimeInterval')"
              :popper-append-to-body="false"
              @blur="
                e => {
                  selectBlur(e, 'isNormalForm', 'netValue')
                }
              "
            >
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <span class="minute">{{ $t('seconds') }}</span>
          </div>
        </el-form-item>
        <el-form-item label="GPS" :required="true">
          <el-radio-group v-model="isNormalForm.GPSRadio" @change="GPSOnOff">
            <el-radio :label="0" value="0">{{ $t('closeN') }}</el-radio>
            <el-radio :label="1" value="1">{{ $t('openN') }}</el-radio>
          </el-radio-group>
          <div class="select-time" v-if="GPSTurn">
            <span class="interval">{{ $t('interval') }}：</span>
            <el-select
              v-model="isNormalForm.GPSValue"
              filterable
              :placeholder="$t('enterTimeInterval')"
              :popper-append-to-body="false"
              @blur="
                e => {
                  selectBlur(e, 'isNormalForm', 'GPSValue')
                }
              "
            >
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <span class="minute">{{ $t('seconds') }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div class="custom">* {{ $t('fillingrange') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{ $t('determine') }}</el-button>
        <el-button @click="normalVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 通话设置/定位设置/其他设置弹窗 -->
    <el-dialog
      :title="isLocation ? $t('callSettings') : isConversat ? $t('positioningSettings') : $t('otherSettings')"
      :visible.sync="OtherVisible"
      :width="isConversat === true && isLocation === false ? '430px' : '550px'"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form :model="isOtherForm">
        <div v-if="isConversat === true && isLocation === false">
          <el-form-item :label="$t('ntervalBaseStation')" :required="true">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.baseStationVal"
                :popper-append-to-body="false"
                filterable
                :placeholder="$t('enterTimeInterval')"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'baseStationVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('seconds') }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('recordingInterval')" :required="true">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.LocationVal"
                :popper-append-to-body="false"
                filterable
                :placeholder="$t('enterTimeInterval')"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'LocationVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('seconds') }}</span>
            </div>
          </el-form-item>
        </div>
        <div v-if="isLocation === true">
          <el-form-item :label="$t('lastVoiceCall')" :required="true" label-width="145px">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.lastTimeVal"
                filterable
                :popper-append-to-body="false"
                placeholder="请输入时间"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'lastTimeVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('afterMinutes') }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('broadcastVoicePayback')" :required="true" label-width="145px">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.voicePlayVal"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('pleaseEnter')"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'voicePlayVal')
                  }
                "
              >
                <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('second') }}</span>
            </div>
          </el-form-item>
        </div>
        <div v-if="isConversat === false && isLocation === false">
          <el-form-item :label="$t('equipmentRecordInterval')" :required="true" label-width="160px">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.equipmentVal"
                :popper-append-to-body="false"
                filterable
                :placeholder="$t('pleaseEnter')"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'equipmentVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('seconds') }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('signRecordingInterval')" :required="true" label-width="160px">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.signVal"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('pleaseEnter')"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'signVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('seconds') }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('timealarmInterval')" :required="true" label-width="160px">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.staticVal"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('pleaseEnter')"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'staticVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('seconds') }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('raiseTheHat')" :required="true" label-width="145px">
            <div class="select-time">
              <el-select
                v-model="isOtherForm.raiseHatVal"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('pleaseEnter')"
                type="number"
                @blur="
                  e => {
                    selectBlur(e, 'isOtherForm', 'raiseHatVal')
                  }
                "
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span class="minute">{{ $t('sleepModeAfterMinutes') }}</span>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div class="custom">* {{ $t('userDefinedFilling') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="otherSubmit">{{ $t('determine') }}</el-button>
        <el-button @click="OtherVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { warning } from '@/api/common'
export default {
  components: {},
  data() {
    return {
      // 页面数据组
      tenantData: {},
      // 设备设置正常/休眠模式 字体显示
      isNormal: false,
      // 设备设置正常/休眠模式 弹窗显示
      normalVisible: false,
      // 设备设置正常/休眠模式 表单参数
      isNormalForm: {
        netRadio: '',
        netValue: '',
        GPSValue: '',
        GPSRadio: '',
      },
      // 网络开启时 显示时间间隔
      turnOn: false,
      // GPS开启时 显示时间间隔
      GPSTurn: false,
      // 选择的时间间隔
      options: [
        {
          value: '60',
          label: '60',
        },
        {
          value: '180',
          label: '180',
        },
        {
          value: '400',
          label: '400',
        },
        {
          value: '600',
          label: '600',
        },
      ],
      // 选择的时间间隔
      optionsTime: [
        {
          value: '1',
          label: '1',
        },
        {
          value: '3',
          label: '3',
        },
        {
          value: '5',
          label: '5',
        },
        {
          value: '10',
          label: '10',
        },
      ],
      // true 时 通话设置
      isLocation: false,
      // true 时定位设置
      isConversat: false,
      // 其他综合表单参数
      isOtherForm: {
        LocationVal: '',
        baseStationVal: '',
        lastTimeVal: '',
        voicePlayVal: '',
        equipmentVal: '',
        signVal: '',
        staticVal: '',
        raiseHatVal: '',
      },
      // 通话设置/定位设置/其他设置 显示弹窗
      OtherVisible: false,
      confirmForm: {},
      formLabelWidth: '150px',
    }
  },
  methods: {
    submitForm() {
      // NOSONAR
      this.confirmForm = this.tenantData
      if (this.isNormal === false) {
        if (this.turnOn === true) {
          this.confirmForm.sleepNetworkModel.value = this.isNormalForm.netValue
          if (this.confirmForm.sleepNetworkModel.value < 0 || this.confirmForm.sleepNetworkModel.value > 1000) {
            warning('*' + this.$t('userDefinedFilling'))
            return
          }
        } else {
          this.confirmForm.sleepNetworkModel.value = -1
        }
        if (this.GPSTurn === true) {
          this.confirmForm.sleepGpsModel.value = this.isNormalForm.GPSValue
          if (this.confirmForm.sleepGpsModel.value < 0 || this.confirmForm.sleepGpsModel.value > 1000) {
            warning('*' + this.$t('userDefinedFilling'))
            return
          }
        } else {
          this.confirmForm.sleepGpsModel.value = -1
        }
      } else {
        if (this.turnOn === true) {
          this.confirmForm.normalNetworkModel.value = this.isNormalForm.netValue
          if (this.confirmForm.normalNetworkModel.value < 0 || this.confirmForm.normalNetworkModel.value > 1000) {
            warning('*' + this.$t('userdefinedFillingRange'))
            return
          }
        } else {
          this.confirmForm.normalNetworkModel.value = -1
        }
        if (this.GPSTurn === true) {
          this.confirmForm.normalGpsModel.value = this.isNormalForm.GPSValue
          if (this.confirmForm.normalGpsModel.value < 0 || this.confirmForm.normalGpsModel.value > 1000) {
            warning('*' + this.$t('userdefinedFillingRange'))
            return
          }
        } else {
          this.confirmForm.normalGpsModel.value = -1
        }
      }
      console.log(this.confirmForm)
      this.updateInfo()
    },
    otherSubmit() {
      this.confirmForm = this.tenantData
      if (this.isLocation === true) {
        //通话设置
        this.confirmForm.outActualModel.value = this.isOtherForm.lastTimeVal
        this.confirmForm.broadcastNumInterval.value = this.isOtherForm.voicePlayVal
      } else if (this.isLocation === false && this.isConversat === true) {
        //定位设置
        this.confirmForm.locationRecordInterval.value = this.isOtherForm.LocationVal
        this.confirmForm.stationStatusRecordInterval.value = this.isOtherForm.baseStationVal
      } else {
        this.confirmForm.deviceStatusRecordInterval.value = this.isOtherForm.equipmentVal
        this.confirmForm.healthStatusRecordInterval.value = this.isOtherForm.signVal
        this.confirmForm.staticAlertRecordInterval.value = this.isOtherForm.staticVal
        this.confirmForm.inSleepModel.value = this.isOtherForm.raiseHatVal
      }
      this.updateInfo()
    },
    updateInfo() {
      tenantUpdate(this.confirmForm).then(res => {
        if (res.state === 0) {
          console.log(res)
          this.getTenantList()
          this.normalVisible = false
          this.OtherVisible = false
        }
      })
    },
    // 通话设置/定位设置/其他设置
    otherSet(type) {
      if (type === 'conversat') {
        this.isLocation = true
        this.isOtherForm.lastTimeVal = this.tenantData.outActualModel.value
        this.isOtherForm.voicePlayVal = this.tenantData.broadcastNumInterval.value
        if (
          this.isOtherForm.lastTimeVal < 1 ||
          this.isOtherForm.lastTimeVal > 1000 ||
          this.isOtherForm.voicePlayVal < 1 ||
          this.isOtherForm.voicePlayVal > 1000
        ) {
          warning('*' + this.$t('userDefinedFilling'))
          return
        }
      } else if (type === 'locat') {
        this.isLocation = false
        this.isConversat = true
        this.isOtherForm.LocationVal = this.tenantData.locationRecordInterval.value
        this.isOtherForm.baseStationVal = this.tenantData.stationStatusRecordInterval.value
        if (
          this.isOtherForm.LocationVal < 1 ||
          this.isOtherForm.LocationVal > 1000 ||
          this.isOtherForm.baseStationVal < 1 ||
          this.isOtherForm.baseStationVal > 1000
        ) {
          warning('*'+this.$t('userDefinedFilling'))
          return
        }
      } else {
        this.isLocation = false
        this.isConversat = false
        this.isOtherForm.equipmentVal = this.tenantData.deviceStatusRecordInterval.value
        this.isOtherForm.signVal = this.tenantData.healthStatusRecordInterval.value
        this.isOtherForm.staticVal = this.tenantData.staticAlertRecordInterval.value
        this.isOtherForm.raiseHatVal = this.tenantData.inSleepModel.value
        if (
          this.isOtherForm.equipmentVal < 1 ||
          this.isOtherForm.equipmentVal > 1000 ||
          this.isOtherForm.signVal < 1 ||
          this.isOtherForm.signVal > 1000 ||
          this.isOtherForm.staticVal < 1 ||
          this.isOtherForm.staticVal > 1000 ||
          this.isOtherForm.raiseHatVal < 1 ||
          this.isOtherForm.raiseHatVal > 1000
        ) {
          warning('*' + this.$t('userDefinedFilling'))
          return
        }
      }
      this.OtherVisible = true
    },
    selectBlur(e, dataKey, key) {
      if (e.target.value) {
        // 不在表单的时候不需要判断，也不需要isname字段
        if (dataKey === 'isNormalForm' && e.target.value >= 0) {
          this[dataKey][key] = e.target.value
        }
        if (dataKey === 'isOtherForm' && e.target.value > 0) {
          this[dataKey][key] = e.target.value
        }
      }
    },
    // 获取个人信息
    getTenantList() {
      tenantList().then(res => {
        if (res.state === 0) {
          this.tenantData = res.data
          console.log(this.tenantData)
        }
      })
    },
    // 正常/休眠模式
    isNormalSet(type) {
      if (type === 'sleep') {
        this.isNormal = false
        this.isNormalForm.netRadio = this.tenantData.sleepNetworkModel.value >= 0 ? 1 : 0
        this.turnOn = this.tenantData.sleepNetworkModel.value >= 0 ? true : false
        this.isNormalForm.netValue = this.tenantData.sleepNetworkModel.value

        this.isNormalForm.GPSRadio = this.tenantData.sleepGpsModel.value >= 0 ? 1 : 0
        this.GPSTurn = this.tenantData.sleepGpsModel.value >= 0 ? true : false
        this.isNormalForm.GPSValue = this.tenantData.sleepGpsModel.value
      } else {
        this._normalSet()
      }
      this.normalVisible = true
    },
    _normalSet() {
      this.isNormal = true
      this.isNormalForm.netRadio = this.tenantData.normalNetworkModel.value >= 0 ? 1 : 0
      this.turnOn = this.tenantData.normalNetworkModel.value >= 0 ? true : false
      this.isNormalForm.netValue = this.tenantData.normalNetworkModel.value

      this.isNormalForm.GPSRadio = this.tenantData.normalGpsModel.value >= 0 ? 1 : 0
      this.GPSTurn = this.tenantData.normalGpsModel.value >= 0 ? true : false
      this.isNormalForm.GPSValue = this.tenantData.normalGpsModel.value
    },
    onOff(e) {
      this.turnOn = e === 0 ? false : true
      if (this.turnOn) {
        this.isNormalForm.netValue = 1
      } else {
        this.isNormalForm.netValue = -1
      }
    },
    GPSOnOff(e) {
      this.GPSTurn = e === 0 ? false : true
      if (this.GPSTurn) {
        this.isNormalForm.GPSValue = 1
      } else {
        this.isNormalForm.GPSValue = -1
      }
    },
  },
  watch: {
    //监听输入框5-1000值
    netValue(newVal, oldVal) {
      if (newVal < 5 || newVal > 1000) {
        this.isNormalForm.netValue = oldVal
      }
    },
    GPSValue(newVal, oldVal) {
      if (newVal < 5 || newVal > 1000) {
        this.isNormalForm.GPSValue = oldVal
      }
    },
    baseStationVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.baseStationVal = oldVal
      }
    },
    LocationVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.LocationVal = oldVal
      }
    },
    lastTimeVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.lastTimeVal = oldVal
      }
    },
    voicePlayVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.voicePlayVal = oldVal
      }
    },
    equipmentVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.equipmentVal = oldVal
      }
    },
    signVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.signVal = oldVal
      }
    },
    staticVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.staticVal = oldVal
      }
    },
    raiseHatVal(newVal, oldVal) {
      if (newVal < 0 || newVal > 1000) {
        this.isOtherForm.raiseHatVal = oldVal
      }
    },
  },
  created() {
    this.getTenantList()
  },
  computed: {
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    isHuaWei: function() {
      return location.host.indexOf('huaweisoft.com') === -1 ? false : true
    },
    //监听输入框0-1000值
    netValue() {
      return this.isNormalForm.netValue
    },
    GPSValue() {
      return this.isNormalForm.GPSValue
    },
    baseStationVal() {
      return this.isOtherForm.baseStationVal
    },
    LocationVal() {
      return this.isOtherForm.LocationVal
    },
    lastTimeVal() {
      return this.isOtherForm.lastTimeVal
    },
    voicePlayVal() {
      return this.isOtherForm.voicePlayVal
    },
    equipmentVal() {
      return this.isOtherForm.equipmentVal
    },
    signVal() {
      return this.isOtherForm.signVal
    },
    staticVal() {
      return this.isOtherForm.staticVal
    },
    raiseHatVal() {
      return this.isOtherForm.raiseHatVal
    },
  },
}
import { tenantList, tenantUpdate } from '@/api/tenantSet'
</script>

<style type="text/css">
.select-time .el-input {
  width: 90px !important;
}
.select-time .el-input input {
  background: var(--search-input-bg) !important;
  border: var(--search-input-border) !important;
  color: #222;
}
.theme-dark .select-time .el-input input {
  color: #fff;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'

.tenant
  width 100%
  .title
    // width 96%
    // margin 22px auto
  .main-content
    width 96%
    margin 0 auto
    overflow hidden
    .bind
      float left
      width 75%
      font-size 16px
      .phone-bind
        display flex
        line-height 90px
        overflow hidden
        .label-bind
          width 310px
          height 90px
          min-width 160px;/*no*/
          span,.typeInfo
            padding-left 47px
        .real-mode
          display flex
          align-items center
          line-height 24px
          .btn-tip
            text-align center
          .typeInfo
            font-size 14px
            font-weight: bold;
            color: #186FD9
        .network
          display flex
          align-items center
          line-height 24px
          width 340px
          font-weight: bold
          span
            padding-left 24px
        .content-bind
          display flex
          align-items center
          line-height 24px
          width 340px
          font-weight: bold
          span
            padding-left 34px
        .bind-btn
          display flex
          align-items center
          justify-content center
          width 350px
          text-align center
          .el-button
            width 100px;/*no*/
      .phone-bind:last-child
        border-bottom: none
      .other-set
        display flex
        line-height 90px
        overflow: hidden
        .other-bind
          width 310px
          min-width 160px;/*no*/
          line-height 165px
          span,.typeInfo
            padding-left 47px
        .other-content
          .other-item
            display flex
            .network
              display flex
              align-items center
              width 316px
              padding-left 24px
              font-weight: bold
            .content-bind
              display flex
              align-items center
              line-height 24px
              width 306px
              padding-left 34px
              font-weight: bold
              flex-shrink:0
              .explain
                margin-right 30px
          .other-item:last-child
            border-bottom: none
        .bind-btn
          display flex
          align-items center
          justify-content center
          width 350px
          text-align center
          .el-button
            width 100px;/*no*/
  .select-time
    display inline-block
    margin-left 20px
  .custom
    font-size: 12px
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #F56C6C
.el-dialog__body
  .custom
    font-size: 12px
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-style: italic;
    color #409eff
  .select-time
    display inline-block
    margin-left 5px
  >>>.el-form-item__label
    argin-right 20px!important
</style>
<style scoped lang="stylus" rel="stylesheet/stylus">
.el-select
  width 95px!important;/*no*/
.el-select-dropdown
  min-width 90px!important
  .el-select-dropdown__item
    text-align center
.el-dialog__title
  font-weight: 500;
</style>
